import RenderInViewPort from 'components/RenderInViewPort/RenderInViewPort';

export default RenderInViewPort;
